import { render } from "./ViewPosts.vue?vue&type=template&id=5b2c9b64&scoped=true"
import script from "./ViewPosts.vue?vue&type=script&lang=js"
export * from "./ViewPosts.vue?vue&type=script&lang=js"

import "./ViewPosts.vue?vue&type=style&index=0&id=5b2c9b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2c9b64"]])

export default __exports__